/**
 * @flow
 * @relayHash 84a41cd2fb8521cc7d0c4c8f0b18e474
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type saveHyblastEditorInput = {|
  clientMutationId?: ?string,
  id: string,
  templateId: string,
  name: string,
  subject: string,
  mms?: ?boolean,
  fields?: ?any,
|};
export type updateEmailTemplateMutationVariables = {|
  input: saveHyblastEditorInput
|};
export type updateEmailTemplateMutationResponse = {|
  +saveHyblastEditor: ?{|
    +hyblastEditor: ?{|
      +templateId: string,
      +rawMacrosHtml: string,
      +substitutedMacrosHtml: string,
      +fields: ?$ReadOnlyArray<{|
        +id: string,
        +label: string,
        +type: string,
        +value: ?string,
        +field: string,
      |}>,
    |}
  |}
|};
export type updateEmailTemplateMutation = {|
  variables: updateEmailTemplateMutationVariables,
  response: updateEmailTemplateMutationResponse,
|};
*/


/*
mutation updateEmailTemplateMutation(
  $input: saveHyblastEditorInput!
) {
  saveHyblastEditor(input: $input) {
    hyblastEditor {
      templateId
      rawMacrosHtml
      substitutedMacrosHtml
      fields {
        id
        label
        type
        value
        field
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "saveHyblastEditorInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "templateId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rawMacrosHtml",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "substitutedMacrosHtml",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "fields",
  "storageKey": null,
  "args": null,
  "concreteType": "EditorField",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "label",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "value",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "field",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "updateEmailTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "saveHyblastEditor",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "saveHyblastEditorPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "hyblastEditor",
            "storageKey": null,
            "args": null,
            "concreteType": "HyblastEditor",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "updateEmailTemplateMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "saveHyblastEditor",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "saveHyblastEditorPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "hyblastEditor",
            "storageKey": null,
            "args": null,
            "concreteType": "HyblastEditor",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "updateEmailTemplateMutation",
    "id": null,
    "text": "mutation updateEmailTemplateMutation(\n  $input: saveHyblastEditorInput!\n) {\n  saveHyblastEditor(input: $input) {\n    hyblastEditor {\n      templateId\n      rawMacrosHtml\n      substitutedMacrosHtml\n      fields {\n        id\n        label\n        type\n        value\n        field\n      }\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '72d4eedecf77beed27b7ccbc04430364';
module.exports = node;
